<template>
    <div class="channel" ref="channel">
        <Scroll
            :scroll.sync="scrollTop"
            @scrollEnd="scrollEnd"
        >
            <Pull-refresh
                v-model="PullRefresh.loading"
                loosing-text="释放刷新数据"
                loading-text="正在刷新数据..." 
                :success-text="PullRefresh.text" 
                @refresh="onRefresh"
            >
            <div class="content">
                <ul>
                    <template  v-for="(item,index) in list">
                        <li :key="index" :class="item.type" @click="go2Detail(index, item.url)">
                            <template v-if="item.type == 'image'">
                                <div class="article_title">{{item.title}}</div>
                                <div class="img_content style_1" v-if="item.imgCount == 1">
                                    <img :src="cmsIsDomain(item.first3Imgs[0])">
                                </div>
                                <div class="img_content style_2" v-else-if="item.imgCount == 2">
                                    <div><img :src="cmsIsDomain(item.first3Imgs[0])"></div>
                                    <div><img :src="cmsIsDomain(item.first3Imgs[1])"></div>
                                </div>
                                <div class="img_content style_3" v-else-if="item.imgCount >= 3">
                                    <div><img :src="cmsIsDomain(item.first3Imgs[0])"></div>
                                    <div>
                                        <div><img :src="cmsIsDomain(item.first3Imgs[1])"></div>
                                        <div>
                                            <template v-if="item.imgCount > 3">
                                                <img :src="cmsIsDomain(item.first3Imgs[2])">
                                                <div class="masking">+{{item.imgCount - 3}}</div>
                                            </template>
                                            <template v-else>
                                                <img :src="cmsIsDomain(item.first3Imgs[2])">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="item.type == 'video'">
                                <div class="article_title">{{item.title}}</div>
                                <div class="video_content">
                                    <video 
                                        :data-index="index"
                                        :src="cmsIsDomain(item.videoUrl)" 
                                        width="100%"
                                        controls 
                                        controlsList="nodownload"
                                        x5-video-player-type='h5' x5-video-player-fullscreen='true' playsinline webkit-playsinline 
                                        preload
                                        @pause="videoPause($event)"
                                        @ended="videoPause($event)"
                                        @error="videoPause($event)"
                                        @click.stop
                                        v-show="videoActiveIndex == index"
                                    >
                                        视频加载失败
                                    </video>
                                    <img class="head_url" :src="cmsIsDomain(item.videoHeadUrl)" v-show="videoActiveIndex != index" @error="e=>e.target.src = require('@images/news/cover@2x.png')">
                                    <YD-image class="icon" src="icon/icon_video_play" @click.native.stop="videoPlay(index)" v-show="videoActiveIndex != index"></YD-image>
                                </div>
                            </template>
                            <template v-else-if="item.type == 'text'">
                                <template v-if="item.covers.length >= 3">
                                    <div class="article_title">{{item.title}}</div>
                                    <div class="img_content style_3">
                                        <div><img :src="item.covers[0]"></div>
                                        <div>
                                            <div><img :src="item.covers[1]"></div>
                                            <div><img :src="item.covers[2]"></div>
                                        </div>
                                    </div>
                                </template>
                                <div class="article_title cover" v-else-if="item.covers.length >= 1">
                                    <p>{{item.title}}</p>
                                    <img :src="item.covers[0]">
                                </div>
                                <div class="article_title" v-else>{{item.title}}</div>
                            </template>
                            <div class="release_info" v-if="isHome">
                                <div>
                                    <YD-image src="icon/top_tab" class="top" v-if="item.top"></YD-image>
                                    <span class="channel_name">{{item.channelName}}</span>
                                </div>
                                <div class="release_time">{{item.addDate | dateFormat('yyyy年M月d日发布')}}</div>
                            </div>
                            <div class="release_info" v-else>
                                <div>
                                    <YD-image src="icon/top_tab" class="top" v-if="item.top"></YD-image>
                                    <div class="release_time">{{item.addDate | dateFormat('yyyy年M月d日发布')}}</div>
                                </div>
                                <div></div>
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
            <Text-prompt :text="loadMore"></Text-prompt>
            </Pull-refresh>
        </Scroll>
    </div>
</template>
<script>
import { PullRefresh } from 'vant';
import 'vant/lib/pull-refresh/style';
import tools from '@/common/tools.js';
import appInteraction from '@/common/appInteraction.js';
export default {
    name:"ChannelLayout",
    components:{
        PullRefresh
    },
    props:{
        channelUrl: String,
        channelId:{
            type: [Number, String],
            default: 0
        },
        isHome: Boolean
    },
    data(){
        return {
            scrollTop: 0,
            scrollH: 0,
            list: [],
            playVideoDom: null,
            videoActiveIndex: -1,
            nextPageUrl: this.channelUrl,
            nextPage: true,
            loadMore: "",
            isGetData: true,
            PullRefresh:{
                loading:false,
                text:''
            },
            OssBase: process.env.VUE_APP_OSS_URL
        }
    },
    created(){
        this.getList();
    },
    mounted(){
        this.scrollH = this.$refs['channel'].offsetHeight;
    },
    watch:{
        scrollTop(scroll){
            this.$emit('scrollChange', scroll);
            if(this.playVideoDom){
                let ch = this.scrollH,
                    videoH = this.playVideoDom.offsetHeight,
                    videoT = this.playVideoDom.parentNode.offsetTop;
                let tabH = tools.remToPx(80);
                if(scroll + tabH > videoH + videoT || scroll + ch < videoT){
                    this.playVideoDom.pause();
                }
            }
        },
        playVideoDom:{
            deep: true,
            handler(newVal){
                this.$emit('playVideo', newVal);
            }
        }
    },
    methods:{
        setScroll(scroll){
            this.scrollTop = scroll;
        },
        getList(isRefresh){
            if(!isRefresh){
                this.loadMore = "加载中";
                this.isGetData = false;
            }
            this.$api.json(this.nextPageUrl).then(data=>{
                let list = this.list;
                if(isRefresh){
                    this.PullRefresh.loading = false;
                    this.PullRefresh.text = "数据刷新成功";
                    list = [];
                }
                let contents = data.contents || [];
                if(!data.hasNextPage || !data.nextPageUrl || contents.length == 0){
                    this.nextPage = false;
                    this.nextPageUrl = "";
                }else{
                    this.nextPage = true;
                    this.nextPageUrl = data.nextPageUrl;
                }
                if(contents.length == 0){
                    this.loadMore = list.length ? "无数据" : '到底了';
                }else{
                    for (let i=0; i<contents.length; i++) {
                        contents[i] = this.changeNewsCoverImgsUrl(contents[i]);
                    }
                    this.$set(this, 'list', [...list, ...contents]);
                    this.loadMore = '';
                    this.isGetData = true;
                }
            }).catch(()=>{
                if(isRefresh){
                    this.PullRefresh.loading = false;
                    this.PullRefresh.text = "数据刷新失败";
                }else{
                    this.loadMore = '加载失败';
                    this.isGetData = true;
                }
            })
        },
        scrollEnd(){
            if(this.isGetData && this.nextPage){
                this.getList();
            }else if(!this.nextPage){
                this.loadMore = '到底了';
            }
        },
        onRefresh(){
            if(this.playVideoDom){
                this.playVideoDom.pause();
            }
            this.nextPageUrl = this.channelUrl;
            this.getList(true)
        },
        go2Detail(index, url){
            if(this.playVideoDom){
                this.playVideoDom.pause();
            }
            let videoDom = this.$el.querySelector(`video[data-index="${index}"]`);
            if(videoDom){
                let currentTime = videoDom.currentTime;
                if(currentTime > 0){
                    if(url.includes('?')){
                        url += `&progress=${currentTime}`;
                    }else{
                        url += `?progress=${currentTime}`;
                    }
                }
            }
            if(url.includes('?')){
                url += '&showbar=true';
            }else{
                url += '?showbar=true';
            }
            url = this.cmsIsDomain(url);
            appInteraction.webviewOpenUrl(url);
        },
        cmsIsDomain(url){
            if(!(/^http|https/.test(url))){
                url = process.env.VUE_APP_CMS_URL + url;
            }
            return url;
        },
        videoPlay(index){
            let target = this.$el.querySelector(`video[data-index="${index}"]`);
            if(this.playVideoDom && this.playVideoDom.getAttribute('data-index') != target.getAttribute('data-index')){
                this.playVideoDom.pause();
            }
            target.play();
            this.playVideoDom = target;
            this.videoActiveIndex = index;
        },
        videoPause({target}){
            if(this.playVideoDom && this.playVideoDom.getAttribute('data-index') == target.getAttribute('data-index')){
                this.playVideoDom = null;
            }
            this.videoActiveIndex = -1;
        },
        changeNewsCoverImgUrl(url, thumb=false) {
            let path = new URL(url).pathname;
            return thumb == true ? `${this.OssBase}/news_cover${path}.jpg` : `${this.OssBase}/news_cover${path}`;
        },
        changeNewsCoverImgsUrl(item) {
            if (item.covers && item.covers.length > 0) {
                if (item.covers.length == 1) {
                    item.covers[0] = this.changeNewsCoverImgUrl(item.covers[0], true);
                } else {
                    for (let i=0; i<item.covers.length; i++) {
                        item.covers[i] = this.changeNewsCoverImgUrl(item.covers[i]);
                    }
                }
            }
            return item;
        }
    }
}
</script>
<style lang="scss" scoped>
.channel{
    height: 100%;
    width: 100%;
}
.channel .content{
    width: 100%;
    height: auto;
    padding-left: 40px;
    box-sizing: border-box;
    ul li{
        width: 100%;
        height: auto;
        padding: 33px 40px 32px 0;
        box-sizing: border-box;
        border-bottom: 1px #F0F0F0 solid;
        &:last-of-type{
            border: none;
        }
        .article_title{
            font-size: 32px;
            color: #1B1C1E;
            font-weight: 500;
            line-height: 44px;
            margin-bottom: 24px;
            &.cover{
                display: flex;
                justify-content: space-between;
                p{
                    width: 412px;
                }
                img{
                    width: 226px;
                    height: 128px;
                    border-radius: 10px;
                    object-fit: cover;
                }
            }
        }
        .img_content{
            width: 100%;
            height: auto;
            margin-bottom: 16px;
            border-radius: 10px;
            overflow: hidden;
            &.style_1{
                height: 476.27px;
            }
            &.style_2{
                height: 236px;
                display: flex;
                justify-content: space-between;
                >div{
                    width: 332px;
                    height: 100%;
                }
            }
            &.style_3{
                height: 316px;
                display: flex;
                justify-content: space-between;
                >div{
                    height: 100%;
                    &:nth-of-type(1){
                        width: 444px;
                    }
                    &:nth-of-type(2){
                        width: 220px;
                        >div{
                            width: 100%;
                            height: 156px;
                            margin-bottom: 4px;
                            &:last-of-type{
                                margin-bottom: 0;
                            }
                            position: relative;
                            .masking{
                                width: 100%;
                                height: 100%;
                                background: rgba(0,0,0,0.60);
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 44px;
                                color: #FFFFFF;
                                font-weight: 500;
                                position: absolute;
                                top: 0;
                                left: 0;
                            }
                        }
                    }
                }
            }
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .video_content{
            width: 100%;
            height: 376px;
            border-radius: 10px;
            overflow: hidden;
            margin-bottom: 16px;
            position: relative;
            background: #1B1C1E;
            .head_url{
                width: 100%;
                height: 100%;
                border-radius: 10px;
                object-fit: cover;
            }
            .icon{
                width: 88px;
                height: 88px;
                position: absolute;
                top: calc(50% - 44px);
                left: calc(50% - 44px);
            }
            video{
                height: 100%;
                width: 100%;
                display: block;
            }
        }
        .release_info{
            display: flex;
            align-items: center;
            justify-content: space-between;
            line-height: 34px;
            font-size: 26px;
            font-weight: 400;
            font-family: PingFangSC-Regular;
            >div{
                &:nth-of-type(1){
                    display: flex;
                    align-items: center;
                    color: #41454D;
                }
                &:nth-of-type(2){
                    color: #999999;
                }
            }
            .top{
                width: 84px;
                height: 38px;
                margin-right: 8px;
            }
        }
    }
}
</style>